const state = {
  breadcrumbs: [],
  drawer: {
    status: true
  },
  snackbar: {
    status: false,
    message: null
  }
}

const mutations = {
  SET_BREADCRUMBS(state, breadcrumbs) {
    state.breadcrumbs = breadcrumbs
  },
  SET_DRAWER(state, drawer) {
    state.drawer = drawer
  },
  SET_SNACKBAR(state, snackbar) {
    state.snackbar = snackbar
  }
}

const actions = {
  setBreadcrumbs({commit}, {breadcrumbs}) {
    commit('SET_BREADCRUMBS', breadcrumbs)
  },
  toggleDrawer({commit, state}) {
    commit('SET_DRAWER', {
      status: !state.drawer.status
    })
  },
  openSnackbar({commit}, {message}) {
    commit('SET_SNACKBAR', {
      status: true,
      message: message
    })
  },
  closeSnackbar({commit}) {
    commit('SET_SNACKBAR', {
      status: false,
      message: null
    })
  }
}

const getters = {}

const layout = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default layout
